<template>
  <my-view></my-view>
</template>

<script>
import MyView from "@/pages/publicView/paymentProcess/payDown_view.vue";

export default {
  components: { MyView },
};
</script>